import { render, staticRenderFns } from "./solution_dynamic_data.vue?vue&type=template&id=5d342704&scoped=true"
import script from "./solution_dynamic_data.vue?vue&type=script&lang=js"
export * from "./solution_dynamic_data.vue?vue&type=script&lang=js"
import style0 from "./solution_dynamic_data.vue?vue&type=style&index=0&id=5d342704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d342704",
  null
  
)

export default component.exports